interface toggleProps {
    onToggle: () => void,
    active: boolean,
    icon: string,
    iconDark: string,
    text: string,
    className?: string
}
export default function ProfileToggleItem({ onToggle, active, icon, iconDark, text, className }: toggleProps) {
    return (
        <div
            onClick={onToggle}
            className={`${active && "bg-indigo-100 text-indigo-600 border-indigo-600"}
            ${className ?? ''} flex justify-center items-center flex-col text-gray-400 w-28 h-14 md:h-28 border-gray-400 border-2 rounded md:p-5 cursor-pointer`}
        >
            {active ?
                <img className='m-auto my-1' alt={text} src={iconDark} />
                :
                <img className='m-auto my-1' alt={text} src={icon} />
            }
            <span className={`${active ? 'text-indigo-600' : ''} hidden md:inline`}>{text}</span>
        </div>
    )
}
